import React from 'react';
import { Box, Container, Grid, Typography } from '@material-ui/core';

const StatisticsSimpleGrid = ({ sectionConfig = {}, globalConfig = {}, layoutContext = {} }) => {
    const { getAnimationProps } = layoutContext;
    const items = sectionConfig.items || globalConfig?.statistics?.items || [];

    if (!items.length) {
        return null;
    }

    const gridSpacing = typeof sectionConfig.grid?.spacing === 'number' ? sectionConfig.grid.spacing : 4;
    const defaultGrid = sectionConfig.gridItem || {};

    const resolveGridValue = (itemValue, fallback) => (typeof itemValue === 'number' ? itemValue : fallback);

    const applyAnimation = (animationConfig, index = 0) => (
        typeof getAnimationProps === 'function' ? getAnimationProps(animationConfig, index) : {}
    );
    const sectionAnimation = applyAnimation(sectionConfig.animation?.section);
    const titleAnimation = applyAnimation(sectionConfig.animation?.title);

    return (
        <Box
            id="statistics-section"
            className={sectionAnimation.className}
            data-anim={sectionAnimation.dataAnim}
            data-delay={sectionAnimation.dataDelay}
            data-trigger-once={sectionAnimation.dataTriggerOnce}
            style={{ ...(sectionConfig.styles || {}), ...(sectionAnimation.style || {}) }}
        >
            <Container maxWidth={sectionConfig.container?.maxWidth || 'lg'} style={sectionConfig.containerStyles || {}}>
                <Box
                    className={titleAnimation.className}
                    data-anim={titleAnimation.dataAnim}
                    data-delay={titleAnimation.dataDelay}
                    data-trigger-once={titleAnimation.dataTriggerOnce}
                    style={{ ...(sectionConfig.titleContainerStyles || {}), ...(titleAnimation.style || {}) }}
                >
                    {sectionConfig.label && (
                        <Typography variant={sectionConfig.typography?.label?.variant || 'body2'} style={sectionConfig.labelStyles || {}}>
                            {sectionConfig.label}
                        </Typography>
                    )}
                    <Typography variant={sectionConfig.typography?.title?.variant || 'h3'} style={sectionConfig.titleStyles || {}}>
                        {sectionConfig.title || globalConfig?.statistics?.title}
                    </Typography>
                    {sectionConfig.subtitle && (
                        <Typography variant={sectionConfig.typography?.subtitle?.variant || 'body1'} style={sectionConfig.subtitleStyles || {}}>
                            {sectionConfig.subtitle}
                        </Typography>
                    )}
                </Box>
                <Grid container spacing={gridSpacing}>
                    {items.map((stat, index) => {
                        const itemAnimation = applyAnimation(sectionConfig.animation?.items, index);
                        const xs = resolveGridValue(stat.gridItem?.xs, defaultGrid.xs || 12);
                        const sm = resolveGridValue(stat.gridItem?.sm, defaultGrid.sm || 6);
                        const md = resolveGridValue(stat.gridItem?.md, defaultGrid.md || 2);
                        const lg = resolveGridValue(stat.gridItem?.lg, defaultGrid.lg);

                        return (
                            <Grid item key={`stat-card-${index}`} xs={xs} sm={sm} md={md} lg={lg}>
                                <Box
                                    className={itemAnimation.className}
                                    data-anim={itemAnimation.dataAnim}
                                    data-delay={itemAnimation.dataDelay}
                                    data-trigger-once={itemAnimation.dataTriggerOnce}
                                    style={{ ...(sectionConfig.itemContainerStyles || {}), ...(itemAnimation.style || {}) }}
                                >
                                    <Typography
                                        variant={sectionConfig.typography?.value?.variant || 'h2'}
                                        style={{
                                            ...(sectionConfig.valueStyles || {}),
                                            color: stat.color || sectionConfig.valueStyles?.color,
                                            textShadow: stat.shadow || sectionConfig.valueStyles?.textShadow
                                        }}
                                    >
                                        {stat.value}
                                    </Typography>
                                    <Typography
                                        variant={sectionConfig.typography?.label?.variant || 'body1'}
                                        style={sectionConfig.labelStyles || {}}
                                    >
                                        {stat.label}
                                    </Typography>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default StatisticsSimpleGrid;
